import { Component, OnInit, EventEmitter } from '@angular/core';
import { Subject, SubscriptionLike } from 'rxjs';
import { UserInstructionModalComponent } from '../user-instruction-modal/user-instruction-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { ModuleMenu, INSTRUCTION, GM_APP } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { Router } from '@angular/router';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { UserService } from 'src/app/services/user.service';
import { SelectApplicationtypeModelComponent } from 'src/app/common/operations-bar/select-applicationtype-model/select-applicationtype-model.component';


@Component({
  selector: 'app-request-type-modal',
  templateUrl: './request-type-modal.component.html',
  styleUrls: ['./request-type-modal.component.scss']
})
export class RequestTypeModalComponent implements OnInit {
  subGetData: SubscriptionLike;

  id: number;
  instructions: [];
  // CME: string;
  // Sponsorship: string;
  // Charitable: string;
  IsCHARITY: boolean = false;
  IsSPONSERSHIP: boolean = false;
  Instruction_Status: boolean = false;
  IsCME: boolean = false;
  instruction: INSTRUCTION;
  menudata: ModuleMenu;
  CME_DisplayName: string = "";
  Sponsership_DisplayName: string = "";
  Charity_DisplayName: string = "";

  constructor(
    private modalService: NgbModal,
    private userService: UserService,
    public modalRef: NgbActiveModal,
    private summaryService: GrantsSummaryService,
    private commonService: CommonService,
    private header: HeadService,
    private router: Router,
    private grantsDataShare: GrantsDatashareService
  ) { }


  ngOnInit() {
    this.GetOrgGrantTypes();
    let OrgDetail = this.commonService.getOrganizationObject(this.userService.getOrgCode());
    if (OrgDetail != null) {
      this.CME_DisplayName = OrgDetail.CME_DISPLAY_NAME;
      this.Sponsership_DisplayName = OrgDetail.SPONSERSHIP_DISPLAY_NAME;
      this.Charity_DisplayName = OrgDetail.CHARITY_DISPLAY_NAME;
    }

  }

  GetOrgGrantTypes() {
    this.subGetData = this.summaryService.getData("api/common/GetOrgGrantTypes").subscribe(
      (res) => {
        if (res["Status"]) {
          this.IsCHARITY = res["Data"].CHARITY;
          this.IsSPONSERSHIP = res["Data"].SPONSERSHIP;
          this.IsCME = res["Data"].CME;
        } else {
          this.IsCHARITY = false;
          this.IsSPONSERSHIP = false;
          this.IsCME = false;
        }
      }
    );
  }
  openUserInstructions(type: any) {
    this.modalRef.dismiss();
    let SubModuleID = "";
    let instructionid = "6"
    if (type === 1) {
      SubModuleID = "GRANTSCME";
      instructionid = "6";
    }
    else if (type === 2) {
      SubModuleID = "GRANTSSPONSORSHIP"
      instructionid = "10";
    }
    else if (type === 3) {
      SubModuleID = "GRANTSCHARITABLE"
      instructionid = "8";
    }

    if (this.instruction != null) {
      this.Instruction_Status = this.instruction.SHOWINSTRUCTIONTOUSER;
    }
    const modalRef = this.modalService.open(SelectApplicationtypeModelComponent, { backdrop: false, windowClass: 'modal-md pt-5' });
    modalRef.componentInstance.Content = {
      heading: 'Select Application Type',
      custommessage: '',
      Proceed: "Proceed",
      Cancel: "Cancel",
      ModuleID: "4",
      SubModuleID: SubModuleID
    }
    modalRef.result.then(result => {

      this.summaryService.getInstruction(result).subscribe(summary => {
        this.instruction = summary;
        if (summary.isINSTRUCTIONS_ID) {
          const modalRef = this.modalService.open(UserInstructionModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-lg right modal-right',
            animation: true
          });
          modalRef.componentInstance.Content = {
            heading: 'Add',
            content: null,
            id: this.id,
            rtype: type,
            ApplicationType: result
          }
        }
        else {
          this.modalRef.dismiss();
          this.commonService.refreshApplicationPage("","grants",result)
        }

      });
    });

  }
}
